import { useEffect } from 'react';

export const getReportIdFromUrl = (pathname: string = window.location.pathname): number | null => {
    const match = pathname.match(/\/reporting\/(\d+)(?=\/|$)/);
    return match ? Number(match[1]) : null;
};

export function useUrlReportIdSync(setSelectedItemId: (id: number | null) => void) {
    useEffect(() => {
        const read = () => setSelectedItemId(getReportIdFromUrl());

        // popstate = back/forward
        window.addEventListener('popstate', read);

        // patch pushState / replaceState to detect SPA navigations
        const origPush = history.pushState;
        const origReplace = history.replaceState;

        history.pushState = function (...args) {
            const ret = origPush.apply(this, args as any);
            read();
            return ret;
        };
        history.replaceState = function (...args) {
            const ret = origReplace.apply(this, args as any);
            read();
            return ret;
        };

        // initial sync
        read();

        return () => {
            window.removeEventListener('popstate', read);
            history.pushState = origPush;
            history.replaceState = origReplace;
        };
    }, [setSelectedItemId]);
}
